<template>
  <nav class="portfolio-spoke-nav" aria-label="Portfolio">
    <div class="spoke-inner">
      <router-link
        to="/clients"
        class="spoke-link"
        :class="{ active: isHub }"
      >
        Hub
      </router-link>
      <router-link
        to="/clients/all"
        class="spoke-link"
        :class="{ active: isClientsAll }"
      >
        All clients
      </router-link>
      <router-link
        to="/projects"
        class="spoke-link"
        :class="{ active: isProjectsAll }"
      >
        All projects
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'PortfolioSpokeNav',
  computed: {
    path() {
      return this.$route.path;
    },
    isHub() {
      return this.path === '/clients' || this.path === '/clients/';
    },
    isClientsAll() {
      return this.path === '/clients/all' || this.path.startsWith('/clients/all/');
    },
    isProjectsAll() {
      return this.path === '/projects' || this.path === '/projects/';
    },
  },
};
</script>

<style scoped>
.portfolio-spoke-nav {
  background: var(--p-surface-elevated, #fff);
  border-bottom: 1px solid var(--p-border, #e2e8f0);
  margin: calc(-1 * var(--spacing-lg, 1.5rem)) calc(-1 * var(--spacing-lg, 1.5rem)) var(--spacing-lg, 1.5rem);
  padding: 0.5rem var(--spacing-lg, 1.5rem);
  position: sticky;
  top: 3.5rem;
  z-index: 40;
}

.spoke-inner {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.spoke-link {
  display: inline-flex;
  align-items: center;
  padding: 0.45rem 0.75rem;
  border-radius: 0.5rem;
  color: var(--p-ink-muted, #64748b);
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
}

.spoke-link:hover {
  background: var(--p-surface-muted, #f1f5f9);
  color: var(--p-ink, #1e293b);
}

.spoke-link.active {
  background: var(--p-accent-subtle, #eef2f8);
  color: var(--p-accent, #1e3a5f);
}
</style>
